(function(){
'use strict';
function init(){
  const drawer=document.getElementById('CartDrawer');
  if(!drawer||drawer.dataset.ztProgressReady==='1')return;
  drawer.dataset.ztProgressReady='1';
  let last=0,bar=null,version=0;
  function update(){
    const next=drawer.querySelector('[data-zeratta-tier-progress]');
    if(!next){bar=null;last=0;return;}
    if(next===bar)return;
    bar=next;
    const fill=next.querySelector('[data-zeratta-tier-fill]');
    if(!fill)return;
    const target=Math.min(100,Math.max(0,Number(next.dataset.progress)||0)),start=last,token=++version;
    last=target;
    fill.style.transition='none';
    fill.style.width=start+'%';
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      if(!fill.isConnected||token!==version)return;
      fill.style.removeProperty('transition');
      fill.style.width=target+'%';
    }));
  }
  new MutationObserver(mutations=>{
    if(mutations.some(m=>m.addedNodes.length||m.removedNodes.length))update();
  }).observe(drawer,{childList:true,subtree:true});
  update();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
else init();
})();